module.exports = __webpack_public_path__ + "assets/img/3e226de8b83bb4ef572c3bd25098e256.svg";